import { render, staticRenderFns } from "./branchTable.vue?vue&type=template&id=068253de&scoped=true&"
import script from "./branchTable.vue?vue&type=script&lang=js&"
export * from "./branchTable.vue?vue&type=script&lang=js&"
import style0 from "./branchTable.vue?vue&type=style&index=0&id=068253de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068253de",
  null
  
)

export default component.exports